import Swal from "sweetalert2";

// ✅ 成功提示
export function showSuccess(message = "操作成功") {
  return Swal.fire({
    icon: "success",
    title: "成功",
    text: message,
    timer: 1500,
    timerProgressBar: true,
    confirmButtonText: "確定",
  });
}

// ✅ 錯誤提示
export function showError(message = "發生錯誤") {
  Swal.fire({
    icon: "error",
    title: "錯誤",
    text: message,
    confirmButtonText: "了解",
  });
}

// ✅ 確認提示（回傳 Promise）
export function showConfirm(message = "你確定要執行此操作嗎？") {
  return Swal.fire({
    icon: "warning",
    title: "請確認",
    text: message,
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "確定",
    cancelButtonText: "取消",
  });
}

// ✅ 提示輸入（回傳 Promise）
export function showPrompt(title = "請輸入資料", inputType = "text") {
  return Swal.fire({
    title,
    input: inputType,
    inputPlaceholder: "請輸入內容",
    showCancelButton: true,
    confirmButtonText: "送出",
    cancelButtonText: "取消",
  });
}

// ✅ Toast 提示（非阻斷）
export function showToast(message = "操作成功", icon = "success") {
  Swal.fire({
    toast: true,
    position: "top-end",
    icon,
    title: message,
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true,
  });
}

// ✅ 顯示處理中 loading
export function showLoading(title = "處理中，請稍候...") {
  Swal.fire({
    title,
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });
}

// ✅ 關閉 loading
export function hideLoading() {
  Swal.close();
}

export function showCustom(title, text, icon = "info") {
  // ✅ 定義 showCustom 函式
  Swal.fire({
    title: title, // 標題
    text: text, // 內容文字
    icon: icon, // 圖示 (success, error, warning, info, question)
    confirmButtonText: "確定", // 確認按鈕文字
  });
}

// ✅ 顯示自訂 HTML
export function showHtmlPopup(title, html, width = 450) {
  return Swal.fire({
    title,
    html,
    width,
    showConfirmButton: false,
  });
}

// ✅ 顯示商品數量選擇彈窗（回傳 Promise）
export async function showQuantitySelector(
  productName,
  stock = 1,
  meter = 1,
  currentQty = 0
) {
  let quantity = currentQty > 0 ? currentQty : 1;

  // 🔵 Meter含義：1 表示有庫存限制，0 表示無上限
  const maxQuantity = meter === 1 ? stock : Infinity;
  const stockText = meter === 0 && stock > 0 ? "有庫存" : `${stock} 件`;

  return Swal.fire({
    title: `${productName}`,
    html: `
      <div style="text-align: center; padding: 20px 0;">
        <p style="font-size: 16px; color: #666; margin-bottom: 25px;">
          ${currentQty > 0 ? "調整購買數量：" : "選擇購買數量："}
        </p>
        
        ${
          currentQty > 0
            ? `
        <p style="font-size: 14px; color: #95a5a6; margin-bottom: 15px;">
          購物車目前數量：${currentQty} 件
        </p>
        `
            : ""
        }
        
        <!-- 數量選擇器 -->
        <div style="
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 0;
          margin-bottom: 20px;
          border: 2px solid #e0e0e0;
          border-radius: 12px;
          overflow: hidden;
          width: 150px;
          margin: 0 auto 20px auto;
          background: #f8f9fa;
        ">
          <button id="decrease" style="
            background: #3498db;
            color: white;
            border: none;
            width: 45px;
            height: 45px;
            font-size: 20px;
            font-weight: bold;
            cursor: pointer;
            transition: all 0.3s ease;
            display: flex;
            align-items: center;
            justify-content: center;
          ">−</button>
          
          <div style="
            flex: 1;
            background: white;
            height: 45px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 18px;
            font-weight: 600;
            color: #2c3e50;
            border-left: 1px solid #e0e0e0;
            border-right: 1px solid #e0e0e0;
          ">
            <span id="qty">${quantity}</span>
          </div>
          
          <button id="increase" style="
            background: #3498db;
            color: white;
            border: none;
            width: 45px;
            height: 45px;
            font-size: 20px;
            font-weight: bold;
            cursor: pointer;
            transition: all 0.3s ease;
            display: flex;
            align-items: center;
            justify-content: center;
          ">+</button>
        </div>
        
        <!-- 庫存提示 -->
        <p style="
          font-size: 12px;
          color: #95a5a6;
          margin: 0;
        ">庫存狀態：${stockText}</p>
        ${
          currentQty > 0
            ? `
        <p style="font-size: 12px; color: #e74c3c; margin-top: 10px;">
          設定為 0 將從購物車移除此商品
        </p>
        `
            : ""
        }
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: currentQty > 0 ? "更新數量" : "加入購物車",
    cancelButtonText: "取消",
    confirmButtonColor: "#3498db",
    cancelButtonColor: "#95a5a6",
    customClass: {
      popup: "custom-quantity-popup",
      confirmButton: "custom-confirm-btn",
      cancelButton: "custom-cancel-btn",
    },
    didOpen: () => {
      const popup = Swal.getPopup();
      const qtyEl = popup.querySelector("#qty");
      const decreaseBtn = popup.querySelector("#decrease");
      const increaseBtn = popup.querySelector("#increase");

      // 設定初始數量
      qtyEl.textContent = quantity;

      // 添加按鈕樣式函數
      const addButtonStyles = (btn, disabled = false) => {
        btn.style.background = disabled ? "#bdc3c7" : "#3498db";
        btn.style.cursor = disabled ? "not-allowed" : "pointer";
        btn.style.opacity = disabled ? "0.6" : "1";
      };

      // 更新按鈕狀態
      const updateButtons = () => {
        // 如果是更新模式，允許減到 0；如果是新增模式，最少為 1
        const canDecrease = currentQty > 0 ? quantity > 0 : quantity > 1;
        addButtonStyles(decreaseBtn, !canDecrease);
        addButtonStyles(increaseBtn, quantity >= maxQuantity);
      };

      // 減少按鈕事件
      decreaseBtn.addEventListener("click", (e) => {
        e.preventDefault();
        const minQty = currentQty > 0 ? 0 : 1;
        if (quantity > minQty) {
          quantity--;
          qtyEl.textContent = quantity;
          updateButtons();
        }
      });

      // 增加按鈕事件
      increaseBtn.addEventListener("click", (e) => {
        e.preventDefault();
        if (quantity < maxQuantity) {
          quantity++;
          qtyEl.textContent = quantity;
          updateButtons();
        }
      });

      // hover 效果
      [decreaseBtn, increaseBtn].forEach((btn) => {
        btn.addEventListener("mouseenter", () => {
          if (btn.style.background !== "#bdc3c7") {
            btn.style.background = "#2980b9";
            btn.style.transform = "scale(1.05)";
          }
        });

        btn.addEventListener("mouseleave", () => {
          if (btn.style.background !== "#bdc3c7") {
            btn.style.background = "#3498db";
            btn.style.transform = "scale(1)";
          }
        });
      });

      // 初始化按鈕狀態
      updateButtons();
    },
    preConfirm: () => quantity,
  });
}

// ✅ 關閉彈窗
export function closePopup() {
  Swal.close();
}
